import type { Post } from '@/@types/post'
import { css } from '@emotion/react'
import { isEmpty } from 'lodash-es'
import { forwardRef } from 'react'
import EmptyPlaceholder from '../EmptyPlaceholder'
import PageLoading from '../PageLoading'
import { ScrollList, ScrollListItem } from '../ScrollList'
import CompositePost from './CompositePost'

export interface PostListProps {
	/**
	 * Post 数据数组
	 */
	data: Post[]
	isFetching?: boolean
}

export default forwardRef<HTMLDivElement, PostListProps>(function PostList(
	{ data, isFetching, ...props }: PostListProps,
	ref
) {
	if (!isFetching && isEmpty(data)) {
		return (
			<EmptyPlaceholder
				title="这里空空如也"
				css={css`
					margin-top: 32px;
				`}
			/>
		)
	}

	return (
		<ScrollList>
			{data.map((post, index) => (
				<ScrollListItem key={post.id} id={post.id}>
					<CompositePost
						data={post}
						css={css`
							box-shadow: 0 0.5px 0 0 var(--tint-separator);
						`}
					/>
				</ScrollListItem>
			))}
			{isFetching && (
				<PageLoading
					noFixed
					css={css`
						margin: 20px 0;
					`}
				/>
			)}
		</ScrollList>
	)
})
